import { inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class MenuService {
    private readonly httpClient = inject(HttpClient);
    getMenuItem() {
        return this.httpClient.get<Response>(`${environment.baseUrl}/settings/menus/tree`);
    }
}
